import { ReactElement, ReactNode } from 'react'
import footerLogo from '../../assets/images/logo-without-shadow.svg'
import { hasDashboardReskinFeatureFlag } from '../molecules/URLFeatureFlag/URLFeatureFlag'
import {
  DASHBOARD_RESKIN_WORDMARK_SIZE_CLASS,
  DASHBOARD_RESKIN_WORDMARK_SRC
} from './dashboardReskinTiles'
import { POINT_BAR_HORIZONTAL_INSET_CLASS } from './PointBar'

interface FooterProps {
  children?: ReactNode
}

const Footer = ({ children }: FooterProps): ReactElement => {
  const useReskinChrome = hasDashboardReskinFeatureFlag()

  return (
    <footer
      className={`flex justify-between w-full${useReskinChrome ? ` items-start ${POINT_BAR_HORIZONTAL_INSET_CLASS}` : ''}`}
    >
      <div className={`flex ${useReskinChrome ? 'items-start' : 'items-center'}`}>
        {useReskinChrome
          ? (
            <img
              src={DASHBOARD_RESKIN_WORDMARK_SRC}
              className={DASHBOARD_RESKIN_WORDMARK_SIZE_CLASS}
              alt='ZenithShield'
            />
            )
          : (
            <>
              <img src={footerLogo} className='w-[156px] cursor-pointer' alt='DopaGE logo' />
              <span className='font-bold text-[38px] leading-[51.91px] text-dopage-lightGreen ml-[18.37px]'>Overdose Prevention Portal</span>
            </>
            )}
      </div>
      {children}
    </footer>
  )
}

export default Footer
